/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Markers_Lists_RequiredInputs */



/**
* | output |
* | --- |
* | "Select at least one marker list that contains markers." |
*
* @param {Iconik_Publish_Markers_Lists_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_markers_lists_required = /** @type {((inputs?: Iconik_Publish_Markers_Lists_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Markers_Lists_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Select at least one marker list that contains markers.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Select at least one marker list that contains markers.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Select at least one marker list that contains markers.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Select at least one marker list that contains markers.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Select at least one marker list that contains markers.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Select at least one marker list that contains markers.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Select at least one marker list that contains markers.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Select at least one marker list that contains markers.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Select at least one marker list that contains markers.")
	return /** @type {LocalizedString} */ ("Select at least one marker list that contains markers.")
});